import { Component } from '@angular/core';

@Component({
  selector: 'app-nodata-found',
  standalone: false,
  templateUrl: './nodata-found.html',
  styleUrl: './nodata-found.scss'
})
export class NodataFound {

}
